// Your people (connections) + your pending sent links.
import { apiFetch } from '../lib/api';

// Active connections — the people you can see overlap with.
export async function listConnections() {
  const res = await apiFetch('/v1/network/connections?status=active');
  return res?.connections || res?.data || [];
}

// Open links you've sent that nobody has accepted yet.
export async function listPendingOpenLinks() {
  const res = await apiFetch('/v1/invitations?status=pending');
  const all = res?.invitations || [];
  return all.filter((i) => i.invite_kind === 'open');
}
